// Fixes a "carousel snaps back to the first slide" bug affecting any
// Flickity carousel configured with imagesLoaded: true (e.g. the homepage
// Featured Collection carousel, and the product image galleries) when its
// slides contain large/slow-loading images.
//
// Root cause: Flickity's own imagesLoaded wiring (bundled inside
// assets/theme.js) calls positionSliderAtSelected() once per INDIVIDUAL
// image's "progress" event as each image in the carousel finishes loading -
// not once after all images are done. On a carousel with several large
// product photos, a shopper can drag to a new slide while an earlier image
// is still mid-decode; that image's late "progress" tick then repositions
// the slider using a selectedIndex that hasn't fully caught up with the
// shopper's just-completed drag, snapping the carousel back to a stale
// slide (often the very first one) right after the shopper moved it. More/
// larger images means more staggered "progress" events and a longer window
// for this race, which is why it's most noticeable on carousels showing
// several big product photos.
//
// Fix: record the shopper's actual selected slide every time select()
// completes (Flickity's own authoritative "a slide change has been
// confirmed" moment - covers drag settle, dot clicks, and arrow clicks),
// then have positionSliderAtSelected() re-assert that recorded index right
// before it does its repositioning math. That way a late, image-load-
// triggered reposition reinforces the shopper's real selection instead of
// snapping back to whatever stale index the mid-flight race left behind.
//
// Patches the shared Flickity.prototype once, following this codebase's
// established pattern of wrapping theme.js-defined functions from a small
// separate file rather than hand-editing the large bundled theme.js (see
// assets/shipping-calculator-fix.js). Since JS prototype methods are looked
// up at CALL time, not at the time each carousel instance is constructed,
// patching the prototype here - before any image finishes loading - covers
// every Flickity instance on the page, including ones created after this
// script runs.
(function () {
  function patchFlickity() {
    if (typeof Flickity === 'undefined' || !Flickity.prototype || Flickity.prototype._imagesLoadedResetFixed) {
      return false;
    }

    var proto = Flickity.prototype;
    var originalSelect = proto.select;
    var originalPositionSliderAtSelected = proto.positionSliderAtSelected;

    proto.select = function () {
      var result = originalSelect.apply(this, arguments);
      this._userSelectedIndex = this.selectedIndex;
      return result;
    };

    proto.positionSliderAtSelected = function () {
      if (this._userSelectedIndex != null && this.selectedIndex !== this._userSelectedIndex) {
        this.selectedIndex = this._userSelectedIndex;
      }
      return originalPositionSliderAtSelected.apply(this, arguments);
    };

    proto._imagesLoadedResetFixed = true;
    return true;
  }

  if (!patchFlickity()) {
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (patchFlickity() || attempts > 60) clearInterval(poll);
    }, 50);
  }
})();
